import ajax from '../utils/request'
const actorApi = {
    getActorList(params) {
        return ajax({
            url: '/api/actor/list',
            type: 'get',
            params
        })
    },
    addActor(params) {
        return ajax({
            url: '/api/actor/create',
            type: 'post',
            params
        })
    },
    updateActor(params) {
        return ajax({
            url: '/api/actor/update',
            type: 'post',
            params
        })
    },
    deleteActor(params) {
        return ajax({
            url: '/api/actor/batch/delete',
            type: 'post',
            params
        })
    }
}
export default actorApi